import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useRecoilValue, useSetRecoilState} from 'recoil';

import {isOpenCommunityWriteAlert} from '../../store';
import {UserInfo} from '../../store/user';

export default function AddContentsBtn() {
  const navigator = useNavigate();
  const userInfo = useRecoilValue(UserInfo);
  const setOpenCommunityWrite = useSetRecoilState(isOpenCommunityWriteAlert);
  const move = () => {
    if (userInfo.userType === 'normal') {
      return setOpenCommunityWrite(true);
    }
    navigator('/community/add');
  };
  return (
    <div
      className="add-community-content-wrapper"
      onClick={() => move()}
      style={{
        display: userInfo.id == -1 ? 'none' : 'flex',
      }}>
      <span className="main-pink-cross-icon">&nbsp;</span>
    </div>
  );
}
